import { useEffect, useRef, type Dispatch, type SetStateAction } from 'react';
import { useSearchUiStore } from '@/stores/searchUiStore';

/**
 * Reopens the extended filter section when the backing grid reports a failed search.
 */
export function useReopenSearchPanelOnFailure(setIsExpanded: Dispatch<SetStateAction<boolean>>) {
  const searchFailureGeneration = useSearchUiStore((state) => state.searchFailureGeneration);
  const previousGeneration = useRef(searchFailureGeneration);

  useEffect(() => {
    if (searchFailureGeneration > previousGeneration.current) {
      setIsExpanded(true);
    }
    previousGeneration.current = searchFailureGeneration;
  }, [searchFailureGeneration, setIsExpanded]);
}
